import axios from "axios";

const instance = axios.create({
  baseURL: process.env.API_URL || "https://nekrodruk.pl/api/api",
  imgURL: process.env.API_URL || "https://nekrodruk.pl/api/uploads",
});

instance.interceptors.request.use((config) => {
  const token = localStorage.getItem("token");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// 403 oznacza też „brak uprawnień” (np. tylko dla właściciela) – wylogowujemy tylko przy nieważnym tokenie
const isInvalidTokenError = (error) => {
  const status = error.response?.status;
  const message = error.response?.data?.message;
  return status === 401 || (status === 403 && typeof message === "string" && /token/i.test(message));
};

instance.interceptors.response.use(
  (response) => response,
  (error) => {
    if (isInvalidTokenError(error)) {
      localStorage.removeItem("token"); // Usuń nieprawidłowy token
      // Sprawdzenie tokenu przy starcie aplikacji nie może przerzucać ze stron publicznych
      // (strona główna, demo, link resetu hasła) na logowanie
      if (!error.config?.url?.includes("/verify-token")) {
        window.location.href = "/login"; // Przekieruj na stronę logowania
      }
    }
    return Promise.reject(error);
  },
);

export default instance;
